import request from '@/utils/request'

// 注册
export function regist(data) {
  return request({
    url: '/index/login/regist',
    method: 'post',
    data: data,
  })
}

// 验证用户名
export function regist_username(name) {
  let obj = {
    username: name
  }
  return request({
    url: '/index/login/regist_username',
    method: 'post',
    data: obj,
  })
}

// 验证手机号
export function regist_phone(phone) {
  let obj = {
    phone: phone
  }
  return request({
    url: '/index/login/regist_phone',
    method: 'post',
    data: obj,
  })
}

// 登录
export function login(userInfo) {
  let obj = {
    username: userInfo.logincode,
    password: userInfo.loginpwd
  }
  return request({
    url: '/index/login/login',
    method: 'post',
    data: obj
  })
}

// 验证身份
export function forget(userInfo) {
  return request({
    url: '/index/login/forget',
    method: 'post',
    data: userInfo
  })
}

// 重置密码
export function editpwd(userInfo) {
  return request({
    url: '/index/login/editpwd',
    method: 'post',
    data: userInfo
  })
}

// 短信登录
export function code_login(userInfo) {
  return request({
    url: '/index/login/code_login',
    method: 'post',
    data: userInfo
  })
}

// 修改手机号
export function edit_phone(userInfo) {
  return request({
    url: '/index/login/edit_phone',
    method: 'post',
    data: userInfo
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js